// extracted by mini-css-extract-plugin
module.exports = {"notice":"Featurebar_notice__wcZ9k","banner":"Featurebar_banner__Ny23o","close-btn":"Featurebar_close-btn__Uc1TU","hide":"Featurebar_hide__SSxhs"};